<template>
    <div>
        <el-form ref="form" :model="form" :rules="rules" label-width="100px">
            <span style="color:brown;font-size:12px;margin-bottom: 10px;"><i>** 妥善保管您的文档。仅在文档遗失或损坏时，应急使用本功能恢复文档。我们并不保证备份文档的完整性和正确性，请自行核对后再使用。** </i> </span>
        <div class="form-group">
        <label for="username">手机号</label>
            <input
              v-model="form.username"
              id="username"
              type="text"
              readonly/>
          <!--短信验证码 -->
          <div class="form-group">
            <label for="sms-code"><span class="required-asterisk">*</span>验证码</label>
            <div class="sms-group">
              <input
                id="sms-code"
                v-model="form.code"
                type="text"
                required
                placeholder="6位验证码"
                maxlength="6">

            <p v-if="smsError" class="error-message">{{ smsError }}</p>
          </div>  
            </div>          
        </div>
        <div class="button-container">
             <el-button
                type="text"               
                :disabled="isCountingDown || !isPhoneValid"
                @click="sendSMSCode(userInfo.username)">                

                <span v-if="!loading"> {{ countdown > 0 ? `${countdown}s后重发` : '获取验证码' }}</span>
                <span v-else>
                  <i class="el-icon-loading"></i> 发送中...
                </span>
             </el-button>
             <el-button type="primary" @click="submitForm">下 载</el-button>
                          <el-button type="plain" @click="closeForm">关 闭</el-button>
        </div>
      </el-form>
    </div>
  </template>

  <script>
  import { mapState } from 'vuex'
  import { get_temp_url } from "@/api/aics/KbDocument.js";
  import { send_sms_code } from '@/api/common'

  export default {
    name: "DocumentDowload",

    props: {
      doc_id:{
        type: Number,
        value: ''
      },
      tenantId:{
        type: Number,
        value: ''
      }

    },
    data() {
      return {
        loading: false,
        countdown: 0,//倒计时
        isPhoneValid: false,
        smsError: '',
        form: {
          username: "",
          code: "",
         doc_id: 0,
        },
        rules: {
          username: [
            { required: true, message: "请输入手机号", trigger: "blur" },            
          ],
          code: [
            { required: true, message: "请输入验证码", trigger: "blur" },
            { min: 6, max: 6, message: "验证码长度为6位", trigger: "blur" }
          ]
        }
      };
    },
    computed: {
    ...mapState('auth', ['tenantInfo', 'userInfo']),
    isCountingDown() {
      return this.countdown > 0
    }

  },
    mounted() {
        this.form.username = this.userInfo.username;
        this.isPhoneValid = /^1[3-9]\d{9}$/.test(this.userInfo.username)
    },
    methods: {
        async sendSMSCode(phone) {
      if (this.isCountingDown || !this.validatePhone(phone)) return;

      try {
        const response = await send_sms_code(phone)
        console.log(response);
        if (response.data &&response.status===200 && response.data.code === 200) {
          this.startCountdown();
          this.$message.success('验证码已发送');
          this.smsError = '';
        } else {
          this.$message.error((response.data && response.data.message) || '发送验证码失败');
        }
      } catch (error) {

        this.$message.error(error);
      }
    },
    validatePhone(phone) {
      this.isPhoneValid = /^1[3-9]\d{9}$/.test(phone)
      if (!this.isPhoneValid) {
        this.$message.error('请输入正确的手机号')
      }
      return this.isPhoneValid
    },
      /** 提交按钮 */
      submitForm: function() {
        this.form.doc_id = this.doc_id
        console.log(this.form)
        if(this.form.username== ''){
          this.$message.error('请输入手机号')
          return;
        }
        if(!this.validatePhone(this.form.username)){
          this.$message.error('请输入有效手机号')
          return;
        }
        if(this.form.code== ''){
          this.$message.error('请输入验证码')
          return;
        }
      this.$refs["form"].validate(valid => {
        if (valid) {
            get_temp_url(this.form).then(response => {
              console.log(response)
              if (response.data && response.data.code=== 200) {
                const url = response.data.message;
                window.open(url);
              } else {
                this.$message.error((response.data && response.data.message) || '下载失败');
            }
            });
          }
        });
      },
      closeForm:function(){
                        this.$emit('submit-success', true);
      },
      startCountdown() {
      this.countdown = 60;
      localStorage.setItem('smsCountdown', Date.now() + 60000); // 存储过期时间

      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
      }

      this.countdownTimer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          clearInterval(this.countdownTimer);
          localStorage.removeItem('smsCountdown');
        }
      }, 1000);
    },

    }
  }
  </script>
<style scoped lang="scss">
  @import '@/styles/variables.scss';
.form-group {
  display: flex;          // 使用 flex 布局
  align-items: center;   // 垂直居中
  margin: 10px 0 10px 0;


  label {
    flex: 0 0 80px;     // 固定 label 宽度
    margin-bottom: 0;    // 移除原来的底部 margin
    padding-right: 15px; // label 和 input 之间的间距
    text-align: right;   // 文字右对齐（可选）
    font-weight: 500;
    color: #474747;
  }

  input {
    padding: 5px 10px;  // 内边距
    border: 1px solid $gray-border;
    border-radius: 6px;
    font-size: 1rem;
    transition: all 0.3s;
    background: rgba(240, 244, 249, 0.5);

    &:focus {
      border-color: #00b4ff;
      box-shadow: 0 0 0 3px rgba(#00b4ff, 0.2);
    }
  }
}

#sms-code {
  width: 20%;
  min-width: 130px;
}
#username{
  width: 25%;
}
.button-container{
  width: 100%;
  text-align: right;
  padding-right: 10px;
}
.sms-group {
  display: flex;
  align-items: center;
  gap: 10px;
}
  .sms-btn {
    background: #00b4ff;
    color: white;
    border: none;
    margin: 0 15px 0 5px;
    height: 30px;
    border-radius: 6px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s;
    white-space: nowrap;

    &:disabled {
      background: #DDD;
      cursor: not-allowed;
    }

    &:not(:disabled):hover {
      background: darken(#00b4ff, 10%);
    }
  }

</style>